import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { Form, Formik, FieldArray } from "formik";
import GeneralComponent from "./GeneralComponent";
import ECommerce from "./ECommerce";
import ProductImages from "./ProductImages";
import { create } from "../../DataApi/create";
import { useSession } from "../../authentications/SessionContext";
import { read } from "../../DataApi/read";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import {
  PRODUCT_ATTRIBUTE_LINE_KEYS,
  PRODUCT_DETAILS_KEYS,
  PRODUCT_VTEX_ATTRIBUTE_LINE_KEYS,
} from "../../utilities/constants";
import { handleResponse } from "../../utilities/handleResponse";
import FormikInput from "../Formik/FormikInput";
import { newProductFormValidationSchema } from "../../utilities/Validation Schema/NewProductFormValidationSchema";
import { write } from "../../DataApi/write";
import SVGButton from "../Buttons/SVGButton";
import cameraIcon from "../../Images/camera.svg";
import NewProductMedia from "./NewProductMedia";
import PublishSocialMedia from "./PublishSocialMedia";
import { onChangeProductMediaImage } from "../../DataApi/products/onChangeProductMediaImage";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import ProductInventory from "./ProductInventory";
import useListOptions from "../../CustomHooks/useListOptions";
import ProductVariants from "./ProductVariants";
import FormikLabel from "../../Components/Formik/FormikLabel";
import { publishOnWebsite } from "../../DataApi/publishWebsite";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import { loadViewGeneral } from "../../DataApi/generalApis/loadViewsGeneral";
import { onChangeGeneral } from "../../DataApi/generalApis/onChangeGeneral";
import {
  getFormattedResponse,
  getLoadViewsData,
} from "../../utilities/getLoadViewsData";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import { handleAddOnChange } from "../../utilities/handleAddOnChange";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import Vtex from "./Vtex";
import { nameCreateGeneral } from "../../DataApi/generalApis/nameCreateGeneral";
import { primaryColor } from "../../utilities/colors";
import Translator from "./Translator";
import Modal from "../Kanban/Modal/Modal";
import SetTranslation from "./SetTranslations";
import { nameSearchGeneral } from "../../DataApi/generalApis/nameSearchGeneral";
import ProductSpecifications from "./ProductSpecifications";
// import { testPayloadData } from "../../utilities/test-data";

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const CheckboxInput = styled.input`
  margin: 0 8px 5px 0px;
`;

const getVTEXInitialValues = (isVTEX) => {
  if (isVTEX)
    return {
      DepartmentId: "",
      Score: "",
      ShowWithoutStock: "",
      TaxCode: "",
      spec_CategoryId: "",
      spec_DefaultValue: "",
      spec_Description: "",
      spec_FieldGroupId: "",
      VtexStatus: "",
      spec_IsFilter: "",
      spec_IsOnProductDetails: "",
      spec_IsRequired: "",
      spec_IsSideMenuLinkActive: "",
      spec_IsStockKeepingUnit: "",
      spec_IsTopMenuLinkActive: "",
      spec_IsWizard: "",
      spec_Position: "",
      spec_name: "",
      VtexBrand: "",
      product_tags_ids: [],
      vtex_status: "",
      availble_on_vtex: "",
    };
  return {};
};

const NewProduct = ({
  handleCloseModal,
  selectedRecord = {},
  refetchData,
  defaultEdit,
  setDefaultEdit,
}) => {
  const { sessionInfo = true } = useSession();
  const {
    company_id,
    context,
    user_id,
    isVTEX = false,
    is_vtex_admin,
    is_vtex_omantal,
    social_media_active,
  } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [categoriesList, setCategoriesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [publicCategoriesList, setPublicCategoriesList] = useState([]);
  const [modalType, setModalType] = useState("view");
  const [productList, setProductList] = useState([]);
  const [selectedMedia, setSelectedMedia] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [websiteId, setWebsiteId] = useState(false);
  const [isPublishedOnWebsite, setIsPublishedOnWebsite] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);

  const [openSocialMediaPostModal, setOpenSocialMediaPostModal] =
    useState(false);

  const image1920Ref = useRef();

  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const { isSubmitting, setIsSubmitting, FormikSubmitButtons } =
    useFormikSubmitButton();

  const [activeTab, setActiveTab] = useState(isVTEX ? 0 : 1);
  const [taxList, setTaxList] = useState([]);
  // const [formFieldsList, setFormFieldsList] = useState([]);
  //vtex states
  const [productBrand, setProductBrand] = useState([]);
  const [productTags, setProductTags] = useState([]);
  const [hasVariants, setHasVariants] = useState(false);
  const [hasVtexAttributes, setHasVtexAttributes] = useState(false);
  const [storedInitialValues, setStoredInitialValues] = useState(() => {
    // Retrieve stored data from localStorage if it exists
    const savedData = localStorage.getItem("storedInitialValues");
    return savedData ? JSON.parse(savedData) : null;
  });

  const [formData, setFormData] = useState({
    name: "",
    sale_ok: false,
    purchase_ok: false,
    litecommerce_count: 0,
    is_litecommerce: false,
    is_category_product: false,
    brand_id: "",
    // available_in_pos: false,
    public_categ_ids: [],
    list_price: 0,
    taxes_id: [],
    standard_price: 0,
    vtex_product_id: "",
    barcode: "",
    hs_code: "",
    weight: "",
    ProHeight: "",
    ProWidth: "",
    ProLength: "",
    volume: "",
    sale_delay: "",
    description_sale: "",
    categ_id: "",
    alternative_product_ids: [],
    image_1920: "",
    default_code: "",
    type: "service",
    temp: {
      name: "",
      video_url: "",
      embed_code: "",
      sequence: "",
    },
    social_image_1920: "",
    product_template_image_ids: [],

    // actualData
  });

  const handleNext = ({
    e,
    validateForm,
    values,
    setErrors,
    setFieldTouched,
    newTabValue = -1,
  }) => {
    e.preventDefault();
    validateForm(values).then((resp) => {
      if (Object.keys(resp)?.length === 0) {
        if (newTabValue !== -1) {
          handleNavigationItemClick(newTabValue, e);
          return;
        }
        setActiveTab(activeTab + 1);
      } else {
        setErrors(resp);
        Object.keys(resp).forEach((key, index) => {
          setFieldTouched(key, true);
        });
      }
    });
  };

  const handleNavigationItemClick = (tabIndex, e) => {
    e.preventDefault();
    e.stopPropagation(); // Stop event propagation
    setActiveTab(tabIndex);
  };

  const handleChangeimage1920 = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue("image_1920", base64));
    }
    if (
      file &&
      !["image/png", "image/jpeg", "image/svg+xml"].includes(file.type)
    ) {
      alert("Unsupported file type. Please select a PNG, JPG, or SVG file.");
      return;
    }
  };

  const getProductTemplateIds = (templates) =>
    templates?.map((temp) => {
      // delete =2 and edit without change =4
      if (temp?.[0] === 4 || temp?.[0] === 2) {
        return [temp[0], temp[1], false];
      } else return temp;
    }) || [];

  const getformattedAttributes = (list = []) => {
    if (list?.length <= 0) return [];
    const formattedAttributes = [];
    list.forEach((item) => {
      if (`${item.id}`.includes("virtual")) {
        if (!item.isDeleted) {
          formattedAttributes.push([
            0,
            item.id,
            {
              name: item.name,
              value: item.value,
            },
          ]);
        }
      } else {
        if (item.isDeleted) {
          formattedAttributes.push([2, item.id, false]);
        } else {
          formattedAttributes.push([
            1,
            item.id,
            {
              name: item.name,
              value: item.value,
            },
          ]);
        }
      }
    });
    return formattedAttributes;
  };
  const getformattedVariants = (list = []) => {
    if (list?.length <= 0) return [];
    const formattedVarients = [];
    list.forEach((item) => {
      if (`${item.id}`.includes("virtual")) {
        if (!item.isDeleted) {
          formattedVarients.push([
            0,
            item.id,
            {
              attribute_id: item.attribute_id,
              value_ids: [[6, false, item.value_ids]],
            },
          ]);
        }
      } else {
        if (item.isDeleted) {
          formattedVarients.push([2, item.id, false]);
        } else {
          formattedVarients.push([
            1,
            item.id,
            {
              attribute_id: item.attribute_id,
              value_ids: [[6, false, item.value_ids]],
            },
          ]);
        }
      }
    });
    return formattedVarients;
  };

  const checkIds = (payload, name) => {
    if (payload?.[name]?.length > 0) {
      return [[6, false, payload?.[name]]];
    }
    return [[6, false, []]];
  };
  const getVTEXFields = (payload) => {
    if (isVTEX) {
      return {
        DepartmentId: payload?.DepartmentId || 0,
        Score: payload?.Score || 0,
        ShowWithoutStock: payload?.ShowWithoutStock || false,
        TaxCode: payload?.TaxCode || 0,
        spec_name: payload?.spec_name || false,
        spec_Description: payload?.spec_Description || false,
        spec_DefaultValue: payload?.spec_DefaultValue || false,
        spec_FieldGroupId: payload?.spec_FieldGroupId || false,
        VtexStatus: payload?.VtexStatus || false,
        spec_IsFilter: payload?.spec_IsFilter || false,
        spec_IsOnProductDetails: payload?.spec_IsOnProductDetails || false,
        spec_IsTopMenuLinkActive: payload?.spec_IsTopMenuLinkActive || false,
        spec_Position: payload?.spec_Position || false,
        spec_IsWizard: payload?.spec_IsWizard || false,
        spec_IsSideMenuLinkActive: payload?.spec_IsSideMenuLinkActive || false,
        product_tags_ids: checkIds(payload, "product_tags_ids"),
        VtexBrand: payload?.VtexBrand || false,
        spec_IsRequired: payload?.spec_IsRequired || false,
        spec_CategoryId: payload?.spec_CategoryId || false,
        spec_IsStockKeepingUnit: payload?.spec_IsStockKeepingUnit || false,
      };
    }
    return {};
  };
  const getPayload = (payload) => {
    if (!selectedRecord?.id) {
      const { temp, ...restPayload } = payload;
      return {
        ...restPayload,
        product_template_image_ids: getProductTemplateIds(
          payload.product_template_image_ids
        ),
        taxes_id: checkIds(payload, "taxes_id"),
        public_categ_ids: checkIds(payload, "public_categ_ids"),
        product_tags_ids: checkIds(payload, "product_tags_ids"),

        alternative_product_ids: checkIds(payload, "alternative_product_ids"),
        attribute_line_ids: getformattedVariants(payload?.attribute_line_ids),
        VtexAttrsIds: getformattedAttributes(payload?.VtexAttrsIds),
      };
    }
    const newPayload = {
      name: payload?.name || false,
      image_1920: payload?.image_1920 || false,
      sale_ok: payload?.sale_ok || false,
      purchase_ok: payload?.purchase_ok || false,
      is_litecommerce: payload?.is_litecommerce || false,
      litecommerce_count: payload?.litecommerce_count || 0,
      is_category_product: payload?.is_category_product || false,
      brand_id: payload?.brand_id || false,
      // available_in_pos: payload?.available_in_pos || false,
      // general
      type: payload?.type || "product",
      categ_id: payload?.categ_id || 1,
      list_price: payload?.list_price || 1,
      taxes_id: checkIds(payload, "taxes_id"),
      standard_price: payload?.standard_price || 0,
      vtex_product_id: payload?.vtex_product_id || false,
      barcode: payload?.barcode || "",
      hs_code: payload?.hs_code || false,
      weight: payload?.weight || 1,
      ProHeight: payload?.ProHeight || 1,
      ProWidth: payload?.ProWidth || 1,
      ProLength: payload?.ProLength || 1,
      volume: payload?.volume || 0,
      sale_delay: payload?.sale_delay || 1,
      related_products_id: payload?.related_products_id || false,
      description_sale: payload?.description_sale || "",
      product_template_image_ids: getProductTemplateIds(
        payload.product_template_image_ids
      ),

      // ecomerece
      public_categ_ids: checkIds(payload, "public_categ_ids"),
      alternative_product_ids: checkIds(payload, "alternative_product_ids"),
      // product images
      social_image_1920: payload.social_image_1920 || "",
      // varient
      attribute_line_ids: getformattedVariants(payload?.attribute_line_ids),
      VtexAttrsIds: getformattedAttributes(payload?.VtexAttrsIds),
      ...getVTEXFields(payload),
      // // extra
      // description_sale: payload?.description_sale || false,
      // uom_id: payload?.uom_id || 1,
      // uom_po_id: payload?.uom_po_id || 1,
      // company_id: payload?.company_id || company_id,
      // packaging_ids: payload?.packaging_ids || [],
      // active: payload?.active || true,
      // default_code: payload?.default_code || false,
      // property_account_income_id: payload?.property_account_income_id || false,
      // property_account_expense_id:
      //   payload?.property_account_expense_id || false,
      // supplier_taxes_id: checkIds(payload, "supplier_taxes_id"),
      // tracking: payload?.tracking || "none",
      // description_picking: payload?.description_picking || false,
      // description_pickingout: payload?.description_pickingout || false,
      // description_pickingin: payload?.description_pickingin || false,
      // route_ids: checkIds(payload, "route_ids"),
      // to_weight: payload?.to_weight || false,
      // pos_categ_id: payload?.pos_categ_id || false,
      // accessory_product_ids: checkIds(payload, "accessory_product_ids"),
      // website_ribbon_id: payload?.website_ribbon_id || false,disableInputs
      // website_sequence: payload?.website_sequence || false,
      // inventory_availability: payload?.inventory_availability || "always",
      // custom_message: payload?.custom_message || "",
      // website_id: payload?.website_id || false,
      // activity_ids: payload?.activity_ids || [],
      // message_follower_ids: payload?.message_follower_ids || [],
      // message_ids: payload?.message_ids || [],
      // is_published: payload?.is_published || false,
      // __last_update: payload?.__last_update || false,
      // asset_category_id: payload?.asset_category_id || false,
      // google_categ_id: payload?.google_categ_id || false,
      // brand: payload?.brand || false,
      // gtin: payload?.gtin || false,
      // mpn: payload?.mpn || false,
      // optional_product_ids: checkIds(payload, "optional_product_ids"),
      // assembly_time: payload?.assembly_time || false,
      // car_parts_installation: payload?.car_parts_installation || false,
      // car_ids: checkIds(payload, "car_ids"),
      // detailed_description: payload.detailed_description || false,
      // related_products_ids: payload.related_products_ids || [],
    };
    return newPayload;
  };
  const handleAddProduct = async (values) => {
    const payload = getPayload(values);
    delete payload.isVTEX;
    delete payload.hasVariants;
    // console.log("payload", payload);
    let response = await create({
      payload,
      context,
      company_id,
      model: "product.template",
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      // refetchData();
      // return;
    }
    return response;
  };
  const handleEditForm = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(formData);
    const newPayload = getPayload(values);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) !== JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    // console.log("newChanges", newChanges);
    let response = await write({
      id: selectedRecord?.id,
      change: newChanges,
      company_id,
      context,
      model: "product.template",
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      // refetchData();
    }
    return response;
  };

  const handleSubmitForm = async (...args) => {
    const [values, { setFieldError, setFieldTouched }] = args;
    // console.log("values on handle submit form", values);
    if (isVTEX) {
      if (!values.VtexBrand) {
        setActiveTab(5);
        setTimeout(() => {
          setFieldTouched("VtexBrand", true);
          setFieldError("VtexBrand", "Brand Id is Required");
        }, 100);
        return;
      }
    }
    setIsSubmitting(true);
    let response = {};
    let successMessage = "Product Created Successfully";

    if (modalType === "edit") {
      successMessage = "Product Edited Successfully";
      response = await handleEditForm(...args);
    } else if (modalType === "add") {
      response = await handleAddProduct(...args);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
    toggleModal();
  };

  const getUpdatedMedia = async (productDetail) => {
    let response = await onChangeProductMediaImage({
      context,
      company_id,
      product_id: productDetail.id,
      product_name: productDetail?.name,
      ids: productDetail?.product_template_image_ids,
      description_sale: productDetail?.description_sale || "",
    });
    return response.result?.map((media) => [4, media.id, { ...media }]);
  };

  const getUpdatedVariants = async (productDetail) => {
    let response = await read({
      id: productDetail.attribute_line_ids,
      change: PRODUCT_ATTRIBUTE_LINE_KEYS,
      company_id,
      context,
      model: "product.template.attribute.line",
    });
    response = JSON.parse(response);
    return response?.result?.map((item) => ({
      id: item.id,
      attribute_id: item.attribute_id?.[0],
      value_ids: item.value_ids,
    }));
  };
  const getUpdatedAttributes = async (productDetail) => {
    let response = await read({
      id: productDetail.VtexAttrsIds,
      change: PRODUCT_VTEX_ATTRIBUTE_LINE_KEYS,
      company_id,
      context,
      model: "product.template.attrs.lines",
    });
    response = JSON.parse(response);
    // console.log("response", response);
    return response?.result?.map((item) => {
      return { id: item.id, name: item.name, value: item.value };
    });
  };

  const handleCreateTags = async (name) => {
    const response = await nameCreateGeneral({
      company_id,
      context,
      args: [name],
      model: "product.template.tags",
    });

    if (response.result) {
      const [value, label] = response?.result;
      findAndAddOption({
        incomingOption: response?.result,
        setAvailableOptions: setProductTags,
      });
      return { value, label };
    }
    return false;
  };
  const handleCreatePublicCategory = async (name) => {
    const response = await nameCreateGeneral({
      company_id,
      context,
      args: [name],
      // kwargs_args: [["website_id.company_id", "=", company_id]],
      model: "product.public.category",
    });

    if (response.result) {
      const [value, label] = response?.result;
      findAndAddOption({
        incomingOption: [response?.result[0], name],
        setAvailableOptions: setPublicCategoriesList,
      });
      return { value, label };
    }
    return false;
  };
  const handleCreateBrand = async (label) => {
    let response = await nameCreateGeneral({
      args: [label],
      context,
      company_id,
      model: "product.template.brand",
    });
    response = response;
    if (response.result) {
      const [value, label] = response?.result;
      // console.log("value,brand............", value, label);

      findAndAddOption({
        incomingOption: response?.result,
        setAvailableOptions: setProductBrand,
      });
      return { value, label };
    }
    return false;
  };

  const fetchProductDetail = async () => {
    // get fields values list

    if (!selectedRecord?.id) return false;
    // let loadViewResponse = await loadViewGeneral({
    //   context,
    //   model: "product.template",
    // });

    // // convert object into list
    // loadViewResponse =
    //   getLoadViewsData({
    //     fieldsObject:
    //       { ...loadViewResponse?.result?.fields_views?.form?.fields } || null,
    //   }) || PRODUCT_DETAILS_KEYS;
    // setFormFieldsList(PRODUCT_DETAILS_KEYS);
    // if (!loadViewResponse) return false;
    let productResponse = await read({
      id: selectedRecord?.id,
      change: [
        ...PRODUCT_DETAILS_KEYS,
        ...Object.keys(getVTEXInitialValues(isVTEX)),
      ],
      company_id,
      context,
      model: "product.template",
    });
    productResponse = JSON.parse(productResponse);
    let productDetail = { ...productResponse?.result?.[0] };
    // console.log("productDetail", productDetail.description_sale);
    if (productDetail) {
      setIsPublishedOnWebsite(productDetail?.is_published);
    }
    if (productDetail?.product_template_image_ids?.length > 0) {
      const updatedMedia = await getUpdatedMedia(productDetail);
      productDetail = {
        ...productDetail,
        product_template_image_ids: updatedMedia,
      };
    }
    if (productDetail?.attribute_line_ids?.length > 0) {
      setHasVariants(true);
      const updatedVariants = await getUpdatedVariants(productDetail);
      // console.log(updatedVariants, "updatedVariants");
      productDetail = {
        ...productDetail,
        attribute_line_ids: updatedVariants,
      };
    }
    if (productDetail?.VtexAttrsIds?.length > 0) {
      setHasVtexAttributes(true);
      const updatedAttributes = await getUpdatedAttributes(productDetail);
      // console.log(updatedAttributes, "updatedAttributes");
      productDetail = {
        ...productDetail,
        VtexAttrsIds: updatedAttributes,
      };
    }
    let respPublicCategIds = await getSelectedOption(
      productDetail?.public_categ_ids,
      "product.public.category"
    );

    let respTaxesIds = await getSelectedOption(
      productDetail?.taxes_id,
      "account.tax"
    );
    const productValues = {
      ...formData,
      ...productDetail,
      taxes_id: productDetail?.taxes_id || "",
      description_sale:
        productDetail?.description_sale !== false
          ? productDetail?.description_sale
          : "",
      categ_id: productDetail?.categ_id?.[0] || "",
      public_categ_ids: productDetail?.public_categ_ids || [],
      product_tags_ids: productDetail?.product_tags_ids || [],

      alternative_product_ids: productDetail?.alternative_product_ids || [],
      image_1920: productDetail?.image_1920 || "",
      vtex_product_id: productDetail?.vtex_product_id || "",
      barcode: productDetail?.barcode || "",
      hs_code: productDetail?.hs_code || "",
      default_code: productDetail?.default_code || "",
      inventory: [],
      VtexBrand: productDetail?.VtexBrand?.[0] || "",
      brand_id: productDetail?.brand_id?.[0] || "",

      additionalOptions: {
        categ: productDetail?.categ_id || "",
        public_categ_ids: productDetail?.public_categ_ids || "",
        brand: productDetail?.brand || "",
        alternative_product: productDetail?.alternative_product_ids || [],
        product_brand: productDetail?.VtexBrand || "",
        taxes_id: respTaxesIds || "",
      },
    };
    // console.log(productValues, "productValues");
    setFormData(productValues);
    return productValues;
  };

  const handleDeleteMedia = (index, values, setFieldValue) => {
    const newValues = [...values.product_template_image_ids] || [];
    if (`${newValues?.[index]?.[1]}`?.includes("virtual")) {
      newValues.splice(index, 1);
    } else {
      newValues[index][0] = 2;
    }
    setFieldValue("product_template_image_ids", newValues);
  };
  const handleEditMedia = (media) => {
    setSelectedMedia(media);
    setIsModalOpen(true);
  };
  const onClickPublishOnWebsite = async (id) => {
    setIsSubmitting(true);
    let publishWebsiteResp = await publishOnWebsite(id);
    publishWebsiteResp = JSON.parse(publishWebsiteResp);
    // console.log("publish on website response", publishWebsiteResp);
    if (publishWebsiteResp?.error?.data?.message) {
      toggleModal();
      setTitle("Access Denied!");
      setMetaData({
        primaryButton: "",
        secondaryButton: "Ok",
        dangerouslySetInnerHTML: publishWebsiteResp?.error?.data?.message,
      });
      setIsSubmitting(false);

      return;
    }
    if (typeof publishWebsiteResp.result !== "undefined") {
      setIsPublishedOnWebsite(publishWebsiteResp?.result);
      refetchData();
      setIsSubmitting(false);
    }
  };
  const handleNewProduct = async () => {
    // if (!storedInitialValues) {
    // console.log("storedInitialValues", storedInitialValues);
    const onchangeResponse = await onChangeGeneral({
      args: {
        id: [],
        values: {},
        keyChange: [],
        defaulChange: {
          product_variant_count: "",
          is_product_variant: "",
          VtexAttrsIds: "",
          "VtexAttrsIds.name": "",
          "VtexAttrsIds.value": "",
          attribute_line_ids: "",
          "attribute_line_ids.attribute_id": "1",
          "attribute_line_ids.value_ids": "",
          is_published: "",
          can_post: "",
          show_on_hand_qty_status_button: "",
          qty_available: "",
          uom_name: "",
          virtual_available: "",
          reordering_min_qty: "",
          reordering_max_qty: "",
          nbr_reordering_rules: "",
          sales_count: "",
          id: "",
          image_1920: "",
          __last_update: "",
          related_is_instagram_active: "",
          name: "1",
          sale_ok: "1",
          purchase_ok: "",
          is_litecommerce: "1",
          litecommerce_count: "",
          is_category_product: "",
          brand_id: "",
          // available_in_pos: "",
          instagram_analytics: "",
          facebook_analytics: "",
          twitter_analytics: "",
          active: "",
          type: "1",
          categ_id: "1",
          default_code: "",
          vtex_product_id: "",
          barcode: "",
          list_price: "",
          pricelist_item_count: "",
          taxes_id: "",
          standard_price: "",
          company_id: `${company_id}`,
          uom_id: "1",
          uom_po_id: "1",
          currency_id: "",
          cost_currency_id: "",
          product_variant_id: "",
          assembly_time: "",
          related_products_id: "",
          car_parts_installation: "1",
          responsible_id: "",
          weight: "",
          ProHeight: "",
          ProWidth: "",
          ProLength: "",
          weight_uom_name: "",
          volume: "",
          volume_uom_name: "",
          sale_delay: "",
          hs_code: "",
          description_sale: "",
          invoice_policy: "",
          service_type: "",
          visible_expense_policy: "",
          expense_policy: "",
          optional_product_ids: "",
          // description_sale: "",
          sale_line_warn: "",
          sale_line_warn_msg: "",
          pos_categ_id: "",
          to_weight: "",
          website_url: "",
          website_id: "",
          website_sequence: "",
          public_categ_ids: "",
          product_tags_ids: "",
          VtexBrand: "",
          inventory_availability: "",
          available_threshold: "",
          custom_message: "",
          alternative_product_ids: "",
          accessory_product_ids: "",
          website_ribbon_id: "",
          supplier_taxes_id: "",
          has_available_route_ids: "",
          route_ids: "",
          route_from_categ_ids: "",
          tracking: "1",
          property_stock_production: "",
          property_stock_inventory: "",
          packaging_ids: "",
          "packaging_ids.name": "",
          "packaging_ids.qty": "",
          "packaging_ids.product_uom_id": "",
          "packaging_ids.company_id": "",
          description_pickingout: "",
          description_pickingin: "",
          description_picking: "",
          car_ids: "",
          "car_ids.name": "",
          "car_ids.model_id": "1",
          "car_ids.maker_name": "",
          detailed_description: "",
          related_products_ids: "",
          "related_products_ids.id": "",
          "related_products_ids.name": "",
          "related_products_ids.list_price": "",
          property_account_income_id: "",
          property_account_expense_id: "",
          asset_category_id: "",
          social_image_1920: "",
          product_template_image_ids: "",
          "product_template_image_ids.id": "",
          "product_template_image_ids.name": "",
          "product_template_image_ids.image_1920": "",
          "product_template_image_ids.sequence": "",
          message_follower_ids: "",
          "message_follower_ids.res_model": "",
          "message_follower_ids.res_id": "",
          "message_follower_ids.partner_id": "",
          "message_follower_ids.channel_id": "",
          activity_ids: "",
          "activity_ids.res_name": "",
          "activity_ids.activity_type_id": "1",
          "activity_ids.summary": "",
          "activity_ids.date_deadline": "",
          message_ids: "",
          "message_ids.date": "",
          "message_ids.subject": "",
          "message_ids.author_id": "",
          "message_ids.model": "",
          "message_ids.res_id": "",
        },
      },
      context,
      company_id,
      model: "product.template",
    });
    const initialValues = handleAddOnChange(onchangeResponse?.result?.value);
    setStoredInitialValues(initialValues);
    setIsLoading(false);

    setFormData({
      ...initialValues,
      name: "",
      description_sale: "",
      vtex_product_id: "",
      barcode: "",
      ...getVTEXInitialValues(isVTEX),
    });
    // } else {
    //   // Skip API call and use the already stored values
    //   setFormData({
    //     ...storedInitialValues,
    //     name: "",
    //     description_sale: "",
    //     vtex_product_id: "",
    //     barcode: "",
    //     ...getVTEXInitialValues(isVTEX),
    //   });
    // }

    // Stop loading indicator
    setIsLoading(false);
  };
  const getSelectedOption = async (id, model) => {
    // console.log("storedInitialValues", storedInitialValues, model);

    let args =
      model === "product.public.category"
        ? [
            ["id", "in", id ? id : []],
            ["website_id.company_id", "=", company_id],
          ]
        : [["id", "in", id ? id : []]];
    let resp = await handleCustomSearch({
      model,
      args: args,
    });
    return resp;
  };
  const setIds = (ids, setState) => {
    if (ids) {
      // console.log("ids", ids);
      ids.map((id) => {
        // console.log(id, "id");
        findAndAddOption({
          incomingOption: [id.value, id.label],
          setAvailableOptions: setState,
        });
      });
    }
  };
  // useEffect(() => {
  //   if (storedInitialValues) {
  //     // Save to localStorage whenever storedInitialValues changes
  //     localStorage.setItem(
  //       "storedInitialValues",
  //       JSON.stringify(storedInitialValues)
  //     );
  //   }
  // }, [storedInitialValues]);

  useEffect(() => {
    const loadSelectedBrand = async () => {
      if (
        formData?.brand_id &&
        !productBrand.find((b) => b.value === formData.brand_id)
      ) {
        const resp = await handleCustomSearch({
          model: "product.template.brand",
          args: [["id", "=", formData.brand_id]],
        });

        if (resp?.[0]) {
          findAndAddOption({
            incomingOption: [resp[0].value, resp[0].label],
            setAvailableOptions: setProductBrand,
          });
        }
      }
    };

    loadSelectedBrand();
  }, [formData?.brand_id]);

  useEffect(() => {
    if (selectedRecord?.id) {
      setModalType("view");
    } else {
      setModalType("add");
    }
    fetchProductDetail().then((response) => {
      if (!response) return handleNewProduct();
      setIsLoading(false);

      const { categ, public_categ_ids, product_brand, taxes_id } =
        response.additionalOptions;
      // console.log("public_categ_ids", public_categ_ids, productBrand);
      findAndAddOption({
        incomingOption: categ,
        setAvailableOptions: setCategoriesList,
      });

      findAndAddOption({
        incomingOption: product_brand,
        setAvailableOptions: setProductBrand,
      });
      // console.log("view yeh to tatti hai");
      handleCustomSearch({
        model: "product.public.category",
        // callButton: true,
        context,
        args: [
          ["id", "in", public_categ_ids],
          ["website_id.company_id", "=", company_id],
        ],
        setState: setPublicCategoriesList,
        publicCategId: public_categ_ids || [],
      });
      // findAndAddOption({
      //   incomingOption: public_categ_ids,
      //   setAvailableOptions: setPublicCategoriesList,
      // });
      // setIds(public_categ_ids, setPublicCategoriesList);
      setIds(taxes_id, setTaxList);
      setIds(product_brand, setProductBrand);
      // const publicCategId = public_categ_ids?.[0];
      // handleCustomSearch({
      //   model: "product.template",
      //   callButton: true,
      //   context,
      //   setState: setPublicCategoriesList,
      //   publicCategId,
      // });
    });
    // console.log("storedInitialValues", storedInitialValues);
    if (!isVTEX) {
      handleCustomSearch({
        model: "product.template.tags",
        setState: setProductTags,
      });
    }
  }, [isVTEX]);
  useEffect(() => {
    if (
      (modalType === "edit" && selectedRecord.id) ||
      modalType === "add"
      // modalType === "view"
    ) {
      const {
        taxes = "",
        categ = "",
        public_categ_ids = "",
        brand = "",
        product_brand = "",
        taxes_id,
      } = formData?.additionalOptions || {};

      // console.log(public_categ_ids, "public_categ_ids");
      // console.log("storedInitialValues", storedInitialValues);
      // handleCustomSearch({
      //   model: "product.template",
      //   callButton: true,
      //   context,
      //   setState: setPublicCategoriesList,
      //   staticOptions: public_categ_ids
      //     ? public_categ_ids.map((publicId) => [publicId.value, publicId.label])
      //     : [],
      // });
      const publicCategId = public_categ_ids;
      // console.log("edit or add yeh to tatti hai", publicCategId);
      handleCustomSearch({
        model: "product.public.category",
        // callButton: true,
        context,
        staticOptions: publicCategoriesList,
        isOptions: true,
        args: [["website_id.company_id", "=", company_id]],
        setState: setPublicCategoriesList,
        publicCategId,
      });
      handleCustomSearch({
        model: "product.category",
        setState: setCategoriesList,
        staticOptions: categ ? [categ] : [],
      });
      handleCustomSearch({
        model: "account.tax",
        setState: setTaxList,
        staticOptions: taxes_id
          ? taxes_id.map((taxId) => [taxId.value, taxId.label])
          : [],
        args: [["type_tax_use", "=", "sale"]],
      });
      handleCustomSearch({
        model: "product.template",
        setState: setProductList,
      });
      handleCustomSearch({
        model: "product.template.brand",
        setState: setProductBrand,
        staticOptions: product_brand ? [product_brand] : [],
      });
      // console.log(
      //   "public categ.................brand",
      //   public_categ_ids,
      //   product_brand
      // );
    }
  }, [modalType]);
  // console.log("isPublishedOnWebsite", isPublishedOnWebsite);
  const disableInputs = useMemo(() => modalType === "view", [modalType]);

  // useEffect(() => {
  //   console.log(formData, "formData");
  // }, [formData]);

  return (
    <>
      <ConfirmationModal />

      {isCreateModalOpen && (
        <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
          <SetTranslation
            handleCloseModal={(modalValue) => setIsCreateModalOpen(false)}
            data={updatedData}
          />
        </Modal>
      )}

      <Formik
        enableReinitialize
        initialValues={{ ...formData, isVTEX: isVTEX }}
        validationSchema={newProductFormValidationSchema(isVTEX)[activeTab]}
        onSubmit={handleSubmitForm}
      >
        {({
          values,
          errors,
          setFieldValue,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <Form>
            {/* {console.log("first", errors, values)} */}
            <div
              className="container"
              style={{ maxWidth: "900px", padding: "10px" }}
            >
              <FormContainer className="row g-3">
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="col">
                    <h3
                      className="me-2 mb-2 "
                      style={{
                        fontFamily: "Inter",
                        color: "#323B4B",
                        fontWeight: 600,
                      }}
                    >
                      {modalType === "add" && t["Add New Product"]}
                      {modalType === "edit" && t["Edit Product"]}
                      {modalType === "view" && t["Product"]}
                    </h3>
                  </div>
                  {modalType === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        onClick={() => {
                          setModalType("edit");
                          if (activeTab === 3) {
                            setActiveTab(0);
                          }
                        }}
                        className="me-2"
                      />
                    </div>
                  )}
                </div>
                <LoaderWrapper
                  isLoading={isLoading}
                  height="70vh"
                  width="800px"
                >
                  <div className="d-flex flex-column flex-md-row">
                    <div
                      className="col-12 col-md-8"
                      style={{ position: "relative" }}
                    >
                      {!disableInputs && (
                        <Translator
                          productId={selectedRecord?.id || ""}
                          color={primaryColor.primary}
                          fieldName={"name"}
                          fieldValue={values.name}
                          isCreateModalOpen={isCreateModalOpen}
                          setIsCreateModalOpen={setIsCreateModalOpen}
                          updatedData={updatedData}
                          setUpdatedData={setUpdatedData}
                        />
                      )}
                      <FormikInput
                        disabled={disableInputs}
                        name="name"
                        maxLength="50"
                        label={t["Product Name"] + " (limit: 50 words)"}
                      />
                    </div>
                    <div
                      className="col-12 col-md-4 product_image_container"
                      onClick={() => {
                        if (!disableInputs) image1920Ref.current.click();
                      }}
                    >
                      <UploadedImage src={values.image_1920 || cameraIcon} />
                      <input
                        ref={image1920Ref}
                        type="file"
                        name="image_1920"
                        hidden
                        accept="image/*"
                        onChange={(e) =>
                          handleChangeimage1920(e, setFieldValue)
                        }
                      />
                    </div>
                  </div>
                  {!isVTEX && (
                    <>
                      <div className="col-6">
                        <CheckboxWrapper>
                          <CheckboxInput
                            disabled={disableInputs}
                            type="checkbox"
                            id="purchase_ok"
                            name="purchase_ok"
                            checked={values.purchase_ok}
                            onChange={(e) => {
                              const { name, checked } = e.target;
                              setFieldValue(name, checked);
                            }}
                          />
                          <FormikLabel name="purchase_ok">
                            {t["Can be Purchased?"]}
                          </FormikLabel>
                        </CheckboxWrapper>
                      </div>
                      <div className="d-flex flex-column">
                        <CheckboxWrapper>
                          <CheckboxInput
                            disabled={disableInputs}
                            type="checkbox"
                            id="sale_ok"
                            name="sale_ok"
                            checked={values.sale_ok}
                            onChange={(e) => {
                              const { name, checked } = e.target;
                              setFieldValue(name, checked);
                            }}
                          />
                          <FormikLabel name="sale_ok">
                            {t["Can be Sold?"]}
                          </FormikLabel>
                        </CheckboxWrapper>
                      </div>
                      <div className="d-flex flex-column">
                        <CheckboxWrapper>
                          <CheckboxInput
                            disabled={disableInputs}
                            type="checkbox"
                            id="is_category_product"
                            name="is_category_product"
                            checked={values.is_category_product}
                            onChange={(e) => {
                              const { name, checked } = e.target;
                              setFieldValue(name, checked);
                            }}
                          />
                          <FormikLabel name="is_category_product">
                            {t["Show in Category Preview?"]}
                          </FormikLabel>
                        </CheckboxWrapper>
                      </div>
                      <div className="d-flex align-items-center">
                        <CheckboxWrapper>
                          <CheckboxInput
                            disabled={
                              disableInputs || values.litecommerce_count === 6
                            }
                            type="checkbox"
                            id="is_litecommerce"
                            name="is_litecommerce"
                            checked={values.is_litecommerce}
                            onChange={(e) => {
                              const { name, checked } = e.target;
                              setFieldValue(name, checked);
                            }}
                          />
                          <FormikLabel name="is_litecommerce">
                            {t["Appear on Storefront?"]}
                          </FormikLabel>
                        </CheckboxWrapper>
                        <div
                          className="d-flex align-items-center justify-content-start"
                          style={{
                            color: primaryColor.primary,
                            marginLeft: "1.5rem",
                            marginBottom: "8px",
                          }}
                        >
                          {6 - values.litecommerce_count}
                          {" item(s) remaining!"}
                        </div>
                      </div>
                      <div>
                        {/* <CheckboxWrapper>
                          <CheckboxInput
                            disabled={disableInputs}
                            type="checkbox"
                            id="available_in_pos"
                            name="available_in_pos"
                            checked={values.available_in_pos}
                            onChange={(e) => {
                              const { name, checked } = e.target;
                              setFieldValue(name, checked);
                            }}
                          />
                          <FormikLabel name="available_in_pos">
                            {t["Available in POS"]}
                          </FormikLabel>
                        </CheckboxWrapper> */}
                      </div>
                    </>
                  )}
                  {selectedRecord?.id && disableInputs && !isVTEX && (
                    <div className="publishBtns col-12">
                      <div className="d-flex align-items-center">
                        <button
                          className="publishWebsite"
                          type="button"
                          onClick={() =>
                            onClickPublishOnWebsite(selectedRecord?.id || false)
                          }
                          disabled={isSubmitting}
                          style={{
                            color: primaryColor.primary,
                            border: "none",
                            backgroundColor: "transparent",
                            fontWeight: "500",
                          }}
                        >
                          <i className="bi bi-globe"></i>
                          <span className="me-2">
                            {isSubmitting
                              ? "Loading..."
                              : t["Publish on Website"]}
                          </span>
                        </button>
                        {!isPublishedOnWebsite ? (
                          <span
                            className="alert alert-danger d-flex align-items-center mb-0"
                            role="alert"
                            style={{
                              height: 12 + "px",
                              padding: "9px !important",
                            }}
                          >
                            <i
                              className="bi bi-exclamation-triangle me-2"
                              style={{
                                fontSize: 12 + "px",
                              }}
                            ></i>
                            <h6
                              className="mb-0"
                              style={{
                                fontSize: 12 + "px",
                              }}
                            >
                              {t["Not Published"]}
                            </h6>
                          </span>
                        ) : (
                          <span
                            className="alert alert-success d-flex align-items-center mb-0"
                            role="alert"
                            style={{
                              height: 12 + "px",
                              padding: "9px !important",
                            }}
                          >
                            <i
                              className="bi bi-patch-check-fill me-2"
                              style={{
                                fontSize: 12 + "px",
                              }}
                            ></i>
                            <h6
                              className="mb-0"
                              style={{
                                fontSize: 12 + "px",
                              }}
                            >
                              {t["Published"]}
                            </h6>
                          </span>
                        )}
                      </div>
                      {!isVTEX && (
                        <PublishSocialMedia
                          isModalOpen={openSocialMediaPostModal}
                          setIsModalOpen={setOpenSocialMediaPostModal}
                          productId={selectedRecord?.id || ""}
                          isPublishedOnWebsite={isPublishedOnWebsite}
                        />
                      )}
                    </div>
                  )}
                  <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                      {isVTEX && (
                        <>
                          <button
                            className={`nav-link ${
                              activeTab === 0 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 0,
                              });
                            }}
                          >
                            {t["Product Details"]}
                          </button>
                          <button
                            className={`nav-link ${
                              activeTab === 1 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 1,
                              });
                            }}
                          >
                            {t["General"]}
                          </button>
                          {modalType === "view" &&
                            values.type !== "service" && (
                              <button
                                className={`nav-link ${
                                  activeTab === 2 ? "active" : ""
                                }`}
                                onClick={(e) => {
                                  handleNext({
                                    e,
                                    validateForm,
                                    values,
                                    setErrors,
                                    setFieldTouched,
                                    newTabValue: 2,
                                  });
                                }}
                              >
                                {t["Inventory"]}
                              </button>
                            )}
                          <button
                            className={`nav-link ${
                              activeTab === 3 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 3,
                              });
                            }}
                          >
                            {t["Variants"]}
                          </button>
                          <button
                            className={`nav-link ${
                              activeTab === 4 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 4,
                              });
                            }}
                          >
                            {t["Attributes"]}
                          </button>
                        </>
                      )}
                      {!isVTEX && (
                        <>
                          <button
                            className={`nav-link ${
                              activeTab === 0 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 0,
                              });
                            }}
                          >
                            {t["General"]}
                          </button>
                          <button
                            className={`nav-link ${
                              activeTab === 1 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 1,
                              });
                            }}
                          >
                            {t["eCommerce"]}
                          </button>
                          {social_media_active && (
                            <button
                              className={`nav-link ${
                                activeTab === 2 ? "active" : ""
                              }`}
                              onClick={(e) => {
                                handleNext({
                                  e,
                                  validateForm,
                                  values,
                                  setErrors,
                                  setFieldTouched,
                                  newTabValue: 2,
                                });
                              }}
                            >
                              {t["Social Media Images"]}
                            </button>
                          )}
                          {modalType === "view" &&
                            values.type !== "service" && (
                              <button
                                className={`nav-link ${
                                  activeTab === 3 ? "active" : ""
                                }`}
                                onClick={(e) => {
                                  handleNext({
                                    e,
                                    validateForm,
                                    values,
                                    setErrors,
                                    setFieldTouched,
                                    newTabValue: 3,
                                  });
                                }}
                              >
                                {t["Inventory"]}
                              </button>
                            )}
                          <button
                            className={`nav-link ${
                              activeTab === 4 ? "active" : ""
                            }`}
                            onClick={(e) => {
                              handleNext({
                                e,
                                validateForm,
                                values,
                                setErrors,
                                setFieldTouched,
                                newTabValue: 4,
                              });
                            }}
                          >
                            {t["Variants"]}
                          </button>
                        </>
                      )}
                    </div>
                  </nav>

                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className={`tab-pane fade  show active`}
                      id="nav-home"
                      role="tabpanel"
                      type="button"
                      aria-labelledby="nav-home-tab"
                      tabIndex="0"
                    >
                      {isVTEX && (
                        <>
                          {activeTab === 0 && (
                            <Vtex
                              disabled={disableInputs}
                              formData={formData}
                              productBrand={productBrand}
                              setProductBrand={setProductBrand}
                              productTags={productTags}
                              handleCustomSearch={handleCustomSearch}
                              handleCreateTags={handleCreateTags}
                              handleCreateBrand={handleCreateBrand}
                              productList={productList}
                              publicCategoriesList={publicCategoriesList}
                              setPublicCategoriesList={setPublicCategoriesList}
                              productId={selectedRecord?.id || ""}
                              fieldName={"description_sale"}
                              fieldValue={values.description_sale}
                              isCreateModalOpen={isCreateModalOpen}
                              setIsCreateModalOpen={setIsCreateModalOpen}
                              updatedData={updatedData}
                              setUpdatedData={setUpdatedData}
                              setIds={setIds}
                            />
                          )}
                          {activeTab === 1 && (
                            <GeneralComponent
                              formData={formData}
                              disabled={disableInputs}
                              productId={selectedRecord?.id || ""}
                              fieldName={"description_sale"}
                              fieldValue={values.description_sale}
                              barcodeValue={values?.barcode}
                              isCreateModalOpen={isCreateModalOpen}
                              setIsCreateModalOpen={setIsCreateModalOpen}
                              updatedData={updatedData}
                              setUpdatedData={setUpdatedData}
                              taxList={taxList}
                              categoriesList={categoriesList}
                              handleCustomSearch={handleCustomSearch}
                              hasVariants={hasVariants}
                            />
                          )}
                          {activeTab === 1 && (
                            <>
                              <NewProductMedia
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                                media={selectedMedia}
                                setMedia={setSelectedMedia}
                                disabled={disableInputs}
                              />
                              <div
                                className="d-flex"
                                style={{ overflow: "auto" }}
                              >
                                {values?.product_template_image_ids?.map(
                                  (image, index) => {
                                    // console.log("image", image);
                                    if (image?.[0] === 2) {
                                      return <></>;
                                    }
                                    if (image?.[2]) {
                                      return (
                                        <div
                                          className="border me-1 position-relative"
                                          style={{ height: 100, width: 100 }}
                                          key={image?.[2].id}
                                        >
                                          <UploadedImage
                                            src={image?.[2]?.image_1920 || ""}
                                          />
                                          {!disableInputs && (
                                            <div className="edit-delete-icons position-absolute top-0 start-0">
                                              <SVGButton
                                                disabled={disableInputs}
                                                hoverColor={
                                                  isVTEX
                                                    ? primaryColor.primary
                                                    : "#ff5837"
                                                }
                                                onClick={() => {
                                                  handleEditMedia(image?.[2]);
                                                }}
                                              />
                                              <SVGButton
                                                disabled={disableInputs}
                                                hoverColor={
                                                  isVTEX
                                                    ? primaryColor.primary
                                                    : "#ff5837"
                                                }
                                                icon={"deleteIcon"}
                                                onClick={() =>
                                                  handleDeleteMedia(
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>
                                      );
                                    }
                                  }
                                )}
                              </div>
                            </>
                          )}
                          {activeTab === 2 &&
                            modalType === "view" &&
                            values.type !== "service" && (
                              <ProductInventory
                                selectedRecord={selectedRecord}
                              />
                            )}
                          {activeTab === 3 && (
                            <FieldArray
                              name="attribute_line_ids"
                              render={({ ...props }) => {
                                return (
                                  <ProductVariants
                                    {...props}
                                    selectedRecord={selectedRecord}
                                    disabled={disableInputs}
                                  />
                                );
                              }}
                            />
                          )}
                          {activeTab === 4 && (
                            <FieldArray
                              name="VtexAttrsIds"
                              render={({ ...props }) => {
                                return (
                                  <ProductSpecifications
                                    {...props}
                                    disabled={disableInputs}
                                  />
                                );
                              }}
                            />
                          )}
                        </>
                      )}
                      {!isVTEX && (
                        <>
                          {activeTab === 0 && (
                            <GeneralComponent
                              formData={formData}
                              disabled={disableInputs}
                              productId={selectedRecord?.id || ""}
                              fieldName={"description_sale"}
                              fieldValue={values.description_sale}
                              isCreateModalOpen={isCreateModalOpen}
                              setIsCreateModalOpen={setIsCreateModalOpen}
                              updatedData={updatedData}
                              setUpdatedData={setUpdatedData}
                              taxList={taxList}
                              categoriesList={categoriesList}
                              handleCustomSearch={handleCustomSearch}
                              hasVariants={hasVariants}
                            />
                          )}
                          {activeTab === 0 && (
                            <>
                              <NewProductMedia
                                isModalOpen={isModalOpen}
                                setIsModalOpen={setIsModalOpen}
                                media={selectedMedia}
                                setMedia={setSelectedMedia}
                                disabled={disableInputs}
                              />
                              <div
                                className="d-flex"
                                style={{ overflow: "auto" }}
                              >
                                {values?.product_template_image_ids?.map(
                                  (image, index) => {
                                    // console.log("image id....", image);
                                    if (image?.[0] === 2) {
                                      return <></>;
                                    }
                                    if (image?.[2]) {
                                      return (
                                        <div
                                          className="border me-1 position-relative"
                                          style={{ height: 100, width: 100 }}
                                          key={image?.[2].id}
                                        >
                                          <UploadedImage
                                            src={image?.[2]?.image_1920 || ""}
                                          />
                                          {!disableInputs && (
                                            <div className="edit-delete-icons position-absolute top-0 start-0">
                                              <SVGButton
                                                disabled={disableInputs}
                                                hoverColor={
                                                  isVTEX
                                                    ? primaryColor.primary
                                                    : "#ff5837"
                                                }
                                                onClick={() => {
                                                  handleEditMedia(image?.[2]);
                                                }}
                                              />
                                              <SVGButton
                                                disabled={disableInputs}
                                                hoverColor={
                                                  isVTEX
                                                    ? primaryColor.primary
                                                    : "#ff5837"
                                                }
                                                icon={"deleteIcon"}
                                                onClick={() =>
                                                  handleDeleteMedia(
                                                    index,
                                                    values,
                                                    setFieldValue
                                                  )
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>
                                      );
                                    }
                                  }
                                )}
                              </div>
                            </>
                          )}
                          {activeTab === 1 && (
                            <ECommerce
                              disabled={disableInputs}
                              formData={formData}
                              productId={selectedRecord?.id || ""}
                              fieldName={"description_sale"}
                              fieldValue={values.description_sale}
                              isCreateModalOpen={isCreateModalOpen}
                              setIsCreateModalOpen={setIsCreateModalOpen}
                              updatedData={updatedData}
                              setUpdatedData={setUpdatedData}
                              publicCategoriesList={publicCategoriesList}
                              setPublicCategoriesList={setPublicCategoriesList}
                              productList={productList}
                              productBrand={productBrand}
                              setProductBrand={setProductBrand}
                              handleCreateBrand={handleCreateBrand}
                              handleCustomSearch={handleCustomSearch}
                              handleCreatePublicCategory={
                                handleCreatePublicCategory
                              }
                              company_id={company_id}
                              isVTEX={isVTEX}
                              is_vtex_admin={is_vtex_admin}
                              is_vtex_omantal={is_vtex_omantal}
                            />
                          )}
                          {activeTab === 2 && (
                            <ProductImages
                              disabled={disableInputs}
                              values={values}
                              setFieldValue={setFieldValue}
                              formData={formData}
                              setFormData={setFormData}
                            />
                          )}
                          {activeTab === 3 &&
                            modalType === "view" &&
                            values.type !== "service" && (
                              <ProductInventory
                                selectedRecord={selectedRecord}
                              />
                            )}
                          {activeTab === 4 && (
                            <FieldArray
                              name="attribute_line_ids"
                              render={({ ...props }) => {
                                return (
                                  <ProductVariants
                                    {...props}
                                    selectedRecord={selectedRecord}
                                    disabled={disableInputs}
                                  />
                                );
                              }}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {/* <ErrorFocus /> */}

                  {!disableInputs && (
                    <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                  )}
                </LoaderWrapper>
              </FormContainer>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewProduct;
